import CreditInfo from './CreditInfo';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import get from 'lodash/get';
import { withUser } from '../../../data-providers/user';
import withCountry from '../../../hocs/withCountry';
import formatPrismicData from '../../../hocs/formatPrismicData';

const enhance = compose(
  withUser,
  withCountry,
  formatPrismicData,
  withProps(props => ({
    credit: get(props, 'user.credit', {
      formatted: '$33.33',
      amount: 33.33,
    }), // TODO Remove default once Eagle API has been updated
  }))
);

export default enhance(CreditInfo);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Account/CreditInfo/index.js